var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useDebouncedValidation } from "../../utility/useDebouncedValidation";
import { RadixInput } from "../../primitives/RadixInput";
export var CardExpirationMonth = function (props) {
    var _a = useFormContext(), control = _a.control, errors = _a.formState.errors, trigger = _a.trigger;
    var debouncedTrigger = useDebouncedValidation(trigger);
    return (React.createElement("div", { className: "radix-form-field" },
        React.createElement(Controller, { name: "expirationMonth", control: control, render: function (_a) {
                var _b;
                var field = _a.field;
                return (React.createElement(RadixInput, __assign({ label: "Expiration Month", type: "tel", value: (_b = field.value) !== null && _b !== void 0 ? _b : "", maxLength: 2, onChange: function (e) {
                        field.onChange(e.target.value);
                        debouncedTrigger("expirationMonth");
                    }, onBlur: field.onBlur, ref: field.ref, placeholder: " " }, props, { "aria-invalid": !!errors.expirationMonth, "aria-describedby": "expirationMonth-error", "aria-label": "Card Expiration Month" })));
            } }),
        errors.expirationMonth && (React.createElement("span", { id: "expirationMonth-error", className: "radix-error-message" },
            React.createElement("i", { className: "fas fa-exclamation-circle" }),
            " ",
            errors.expirationMonth.message))));
};
